export const QUERY_KEY_COMPANY_SETTINGS = 'QUERY_KEY_COMPANY_SETTINGS'

export const QUERY_KEY_FAST_PRODUCT_ENABLEMENT =
  'QUERY_KEY_FAST_PRODUCT_ENABLEMENT'

export const MUTATION_KEY_COMPANY_SETTINGS = 'MUTATION_KEY_COMPANY_SETTINGS'
